module.exports = __webpack_public_path__ + "img/financial_money.275cef36.svg";